import { render, staticRenderFns } from "./adv-item.vue?vue&type=template&id=29d1d38a&scoped=true"
import script from "./adv-item.vue?vue&type=script&lang=js"
export * from "./adv-item.vue?vue&type=script&lang=js"
import style0 from "./adv-item.vue?vue&type=style&index=0&id=29d1d38a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d1d38a",
  null
  
)

export default component.exports